define('Adobe/eventListeners',["util"], function (util) {
    return {
        run: function () {
            //Widgets.
            $("div[class*='adl-widget']").on("click", function (e) {
                var $this = $(this);
                var parentRow = $this.closest(".outerRow");
                var BHsearchMethodWidgetType = $this.attr('class').split(' ')[1];
                var BHsearchMethodPagePosition_pt1 = "centre";
                var BHsearchMethodPagePosition_pt2 = parentRow.attr('data-rownumber');
                var BHsearchMethodPagePosition_pt3 = 0;

                if ($this.attr("id") !== "carousel") {
                    BHsearchMethodPagePosition_pt3 = (parentRow.find("div[class*='adl-widget']").index(this)) + 1;
                }

                BHsearchMethodPagePosition = BHsearchMethodPagePosition_pt1 + "-" + BHsearchMethodPagePosition_pt2 + "-" + BHsearchMethodPagePosition_pt3;

                var pathname = window.location.pathname;
                var BHsearchMethodPageType = "homepage";

                if (pathname !== "/") {
                    BHsearchMethodPageType = localStorage.getItem("BHsearchMethodPageType") || "";
                }

                AdlAddUpdateItem("BHsearchMethodPageType", BHsearchMethodPageType);
                AdlAddUpdateItem("BHsearchMethodWidgetType", BHsearchMethodWidgetType);
                AdlAddUpdateItem("BHsearchMethodPagePosition", BHsearchMethodPagePosition);

                util.satelliteTrack('travelSearchWidget');
            });

            // Add adobe dl info when any page link is clicked
            $("a").on("click", function () {
                var $this = $(this);

                if ($this.children('img').length >= 1) {
                    //image clicked
                    AdlAddUpdateItem("BHsearchMethodLinkType", "image");
                } else if ($this.hasClass("btn")) {
                    //btn clicked
                    AdlAddUpdateItem("BHsearchMethodLinkType", "cta");
                } else {
                    //text clicked
                    AdlAddUpdateItem("BHsearchMethodLinkType", "text");
                };

                // Add itinerary values
                //$("#itinerary a.innerTabLink").click(function () {
                if (($this.hasClass('innerTabLink')) && ($this.parents('#itinerary').length > 0)) {
                    var dayOverview = $this.text().trim().replace(/\n|\r/g, "^");
                    var dayParts = dayOverview.split("^");
                    var day = dayParts[0].trim() + "|" + dayParts[1].trim();

                    // also insert itinerary day overview into adl variables
                    AdlAddUpdateItem('dayOverview', day);
                    util.satelliteTrack('day overview click');
                } else if (($this.hasClass('question')))  //FAQ Pages
                {
                    var faqQuestion = $this.text().trim();
                    // insert into adl variables & call satellite track
                    AdlAddUpdateItem('FAQ', faqQuestion);
                    util.satelliteTrack('faq interaction');
                } else {
                    var ctaURL = this.href;

                    if (ctaURL === undefined) {
                        ctaURL = this.innerText.trim();
                    } else if ((ctaURL.toLowerCase().indexOf("void") >= 0) || (ctaURL === "")) {
                        ctaURL = this.innerText.trim();
                    }

                    // brochure 'read online' link, not a PDF
                    if ($this.parents('.brochureChoices').length > 0) {
                        ctaURL = $this.parents('.brochureChoices').find('h2').text().trim();
                    }

                    // check if this is a pdf download
                    if (ctaURL.toLowerCase().indexOf(".pdf") >= 0) {
                        //remove domain from pdf url
                        AdlAddUpdateItem('brochureName', ctaURL.replace(/.*\/\/[^\/]*/, ''));

                        util.satelliteTrack('booklet download');

                    } else {
                        var locationInPage = "";

                        if ($this.parents('.adl-megaNav').length > 0) {
                            if ($this.parents('.megaNavMenu').length === 0) {
                                ctaURL = this.innerText.trim();
                            }

                            locationInPage = 'navigation';
                        } else if ($this.parents('.adl-leftNav').length > 0) {
                            locationInPage = 'side navigation menu';
                        } else if ($this.parents('.adl-navigation').length > 0) {
                            locationInPage = 'navigation';
                        } else if ($this.parents('.adl-header').length > 0) {
                            locationInPage = 'header';
                        } else if ($this.parents('.adl-footer').length > 0) {
                            locationInPage = 'footer';
                        } else {
                            locationInPage = 'content';
                        }

                        AdlAddUpdateItem('locationInPage', locationInPage);
                        AdlAddUpdateItem('ctaURL', ctaURL);

                        util.satelliteTrack('location in page');
                    }
                }
            });

            //Social media buttons.
            $('.adl-socialBtn').each(function () {
                $(this).on('click', function () {
                    var currentPageUrl = $(document).attr('title');
                    var socialUrl = $(this).attr('href');
                    var socialTitle = $(this).children('.adl-socialImg').attr('alt');
                    var socialMediaButtons = socialTitle + ' | ' + socialUrl + ' | ' + currentPageUrl + ' | ' + 'footer';
                    //alert(socialMediaButtons);
                    AdlAddUpdateItem("social", socialMediaButtons);
                    util.satelliteTrack('social interaction');
                });
            });

            //Brochures.
            var getCurrentUrl = window.location.href.toLowerCase();
            if (getCurrentUrl.indexOf("brochures-requested") > -1 && getCurrentUrl.indexOf("brochure-request-submitted.aspx?success=true") === -1) {
                var selectedBrochures = [];
                $('.brochure-list #selectedBrochures li').each(function () {
                    var getBrochureText = $(this).find('p').text().trim().toLowerCase();
                    selectedBrochures.push(getBrochureText);
                });
                AdlAddUpdateItem("brochureName", selectedBrochures.join(" | "));
                localStorage.setItem("brochureName", selectedBrochures.join(" | "));
                util.satelliteTrack('brochure order');
            }

            //Forms.
            $('.adl-form select').on('change', function () {
                //only do this if it's not a brochure request page - brochure request title stores the name of the brochure!
                if (window.location.pathname.indexOf('request-a-brochure') == -1) {
                    var ddv = this.value;
                    AdlAddUpdateItem("Title", ddv);
                }
            });

            $('.adl-form label').each(function () {
                $(this).on('click', function () {
                    //var labelValue = $(this).text();
                    var labelName = $(this).attr('for');
                    //alert(labelName + " | " + labelValue);
                    AdlAddUpdateItem(labelName, "checked");
                });
            });

            window.loadedModules('Adobe/eventListeners');
        }
    }
});
